import { render, staticRenderFns } from "./EmrXrayOPD.vue?vue&type=template&id=0f6a335a&"
import script from "./EmrXrayOPD.vue?vue&type=script&lang=js&"
export * from "./EmrXrayOPD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports